<template>
	<div id="content">
		<div class="row mt-5">
			<div class="col-md-4">
			</div>
			<div class="col-md-3">
				<b-alert show variant="danger" v-if="error" class="mb-2">{{error}}</b-alert>
				<h2>Login</h2>
				Email: <b-form-input class="mb-2" v-model="username" placeholder="Enter your Email Address"></b-form-input>
				Password: <b-form-input class="mb-2" v-model="password" type="password"></b-form-input>
				<b-button @click="login">Login</b-button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Login',
	data() {
	return{
		username: "",
		password: "",
		token: String,
		error: null,
	}
	},
	methods: {
		login: function(){
			this.$http.post(
				this.$config.ApiUri + "/Sessions", 
				{"userName": this.username, "password": this.password})
				.then((result) => {
					this.token = result.data.session.token;
					if (this.checkIsAdminOrEditor()) {
						this.$cookies.set("token", this.token, new Date(new Date().getTime() + 20 * 60 * 1000));
						this.$http.defaults.headers.common = {
							"Authorization": "bearer " + this.token
						};
						this.$router.push('/home');
					} else {
						this.showError("You do not have sufficient permission.  Please contact Tris");
					}
				}
			).catch(() => { this.showError(); })
		},
		showError(message) {
			if (!message) { message = "Login failed, please try again"; }
			this.error=message;
			setTimeout(() => this.error = null, 6000);
		},
		parseJwt: function(token) {
			var base64Url = token.split('.')[1];
			var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
			var jsonPayload = decodeURIComponent(Buffer.from(base64, "base64").toString("ascii").split("").map(function(c) {
				return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
			}).join(''));
			return JSON.parse(jsonPayload);
		},
		checkIsAdminOrEditor: function() {
			var t = this.parseJwt(this.token);
			var admin = t["custom:admin"] != null && t["custom:admin"] == "true";
			var editor = t["custom:editor"] != null && t["custom:editor"] == "true";
			var psmeditor = t["custom:psmeditor"] != null && t["custom:psmeditor"] == "true";
			return admin || editor || psmeditor;
		}
	},
	mounted: function() {
		setTimeout(() => this.$bvToast.show('login-toast'), 1000);
		
	}
}
</script>


<style>

</style>